import {
  IconButton,
  LockIcon,
  TableCell,
  Tooltip,
  TooltipInteractiveWrapper,
  TrashIcon,
} from '@razorpay/blade/components';
import React from 'react';
import { useSalaryStructure } from '../context/SalaryStructureProvider';
import { SalaryStructureComponentProps } from '../types';
import { isComponentDeletable } from '../utils';

const ActionCell = ({ item }: SalaryStructureComponentProps) => {
  const { removeComponent } = useSalaryStructure();
  const isDeletable = isComponentDeletable(item);

  return (
    <TableCell>
      {isDeletable ? (
        <IconButton
          size="medium"
          isHighlighted
          icon={TrashIcon}
          accessibilityLabel="Delete"
          onClick={() => removeComponent(item.id.toString())}
        />
      ) : (
        <Tooltip content="Component is required in the salary structure as per government compliance">
          <TooltipInteractiveWrapper
            display="grid"
            placeItems="center"
            width="100%"
            minWidth="spacing.8">
            <LockIcon color="surface.icon.gray.disabled" size="medium" />
          </TooltipInteractiveWrapper>
        </Tooltip>
      )}
    </TableCell>
  );
};

export default ActionCell;
